module.exports = __webpack_public_path__ + "img/MainBG2.673c2bb0.png";